<template>
    <BaseNew
        @new-confirm-action="createEntry"
        @new-cancel-action="resetForm"
        @new-open-action="loadServerEntry"
        @clear-form-errors="clearFormErrors"
        ref="baseNew"
        width="80%"
        :formErrors="formErrors"
        :loading="loading"
        addButtonIcon="mdi-tractor"
        :inlineAddButton="true"
        :pageLoading="pageLoading"
        :modelNameSingular="modelNameSingular">
        <template slot="newForm">
            <BaseUtil ref="util" :pageLoading="pageLoading" />
            <v-row>
                <v-col cols="12" sm="6">
                    <DateField
                        :inputData.sync="date"
                        label="Data do 1o semeio"
                        :hasTodayButton="true"
                        :hasTodayDate="true"
                        autocomplete="off" />
                </v-col>
                <v-col cols="12" sm="6">
                    <DateField
                        :inputData.sync="estimatedDeliveryDate"
                        label="Data estimada de entrega"
                        :hasTodayButton="true"
                        :hasTodayDate="true"
                        autocomplete="off" />
                </v-col>
                <v-col cols="12" sm="6">
                    <MaskedTextField
                        :inputData.sync="interval"
                        mask-type="integer"
                        label="Intervalo de dias entre semeios"
                        suffix="dia(s)"
                        autocomplete="off" />
                </v-col>
                <v-col cols="12" sm="6">
                    <MaskedTextField
                        :inputData.sync="quantity"
                        mask-type="integer"
                        label="Número de semeios"
                        autocomplete="off" />
                </v-col>
            </v-row>
        </template>
    </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
// import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";
import BaseUtil from "@shared_components/base_util.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue";
import DateField from "@shared_components/date_field.vue";

export default {
    data() {
        return {
            error: null,
            loading: false,
            pageLoading: false,
            entry: null,
            formErrors: [],
            extraData: null,
            interval: null,
            quantity: null,
            date: null,
            estimatedDeliveryDate: null,
        };
    },
    props: {
        modelNameSingular: String,
        saleOrder: Object, 
    },
    components: {
        // Form: Form,
        BaseNew: BaseNew,
        BaseUtil: BaseUtil,
        MaskedTextField: MaskedTextField,
        DateField: DateField,
    },
    created: function(){
      this.interval = 1;
      this.quantity = 1;
    },
    methods: {
        loadServerEntry: function () {
            this.error = null;
            this.loading = false;
            // this.$apollo
            //   .query({
            //     query: LOAD_NEW_SALE_ORDER_QUERY,
            //     fetchPolicy: "no-cache"
            //   })
            //   .then(response => {
            //     this.entry = response.data.accountContext.saleOrder;
            //     this.extraData = response.data;
            //   })
            //   .catch(response => console.log(response))
            //   .finally(() => (this.loading = false));

        },
        createServerEntry: function (saleOrder) {
            // console.log("saleOrder", saleOrder, saleOrder.validations, this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations));
            this.pageLoading = true;
            this.$apollo
                .mutate({
                    mutation: CREATE_MULTIPLE_SEED_PLOT_OPERATION_MUTATION,
                    variables: {
                        interval: this.interval, 
                        estimatedDeliveryDate: this.estimatedDeliveryDate+"",
                        quantity: this.quantity,
                        firstSowing: this.date+"",
                        saleOrderId: this.saleOrder.id,
                    }
                })
                .then(response => {
                    var error = response.data.createMultiplePlanningSeedPlotOperation.success

                    if (error) {
                        // this.formErrors = errors
                        this.$refs.baseNew.closeDialog();
                        // this.resetForm();
                        this.$emit("entry-created");
                    } else {
                      console.log("erro");
                    }
                })
                .catch(error => {
                    let {
                        graphQLErrors,
                        networkError,
                        response,
                        operation
                    } = error;
                    console.log("error", error)
                    console.log("caiu no catch");
                    console.log(graphQLErrors);
                    console.log(networkError);
                    console.log(response);
                    console.log(operation);
                    if(graphQLErrors){
                      // console.log("err");
                      this.formErrors = ["Todos os campos devem ser preenchidos."];
                    }
                    if (networkError) {
                        console.log(`[Network error]: ${networkError}`);
                    } else if (graphQLErrors) {
                        graphQLErrors.map(({
                                message,
                                locations,
                                path
                            }) =>
                            console.log(
                                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                            )
                        );
                    }
                })
                .finally(() => (this.pageLoading = false));
        },
        createEntry: function () {
            // if (this.$refs.form.isFormValid()) {
                this.createServerEntry(this.entry);
            // }
        },
        resetForm: function () {
            if (this.$refs.form) {
                this.$refs.form.resetFormInputs();
            }
            this.formErrors = [];
        },
        clearFormErrors: function () {
            this.formErrors = [];
        }
    }
};

const LOAD_NEW_SALE_ORDER_QUERY = gql `
  {
    accountContext {
      saleOrder {
        id
        code
        date
        saleOrderTime
        billDate
        estimatedDeliveryDate
        fiscalDocumentType
        orderValidity
        customerId
        totalPrice
        observation
        validations
        carrierId
        carrier {
          id
        }
        carriageModalityId
        carriageModality {
          id
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyExitMovementItemsAttributes {
          id
          price
          quantity
          packagingQuantity
          itemId
          storageId
          isNewItemInStorage
          unitPrice
          packagingUnitName
          packagingPrice
          item {
            id
            name
            description
            unit {
              name
            }
          }
          storage {
            id
            name
          }
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allCustomers {
        id
        name
      }
      allCarriers {
        id
        name
      }
    }
    globalContext {
      allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const CREATE_MULTIPLE_SEED_PLOT_OPERATION_MUTATION = gql `
  mutation($interval: Int!, $quantity: Int!, $firstSowing: String!, $estimatedDeliveryDate: String!, $saleOrderId: ID!) {
    createMultiplePlanningSeedPlotOperation(interval: $interval, quantity: $quantity, firstSowing: $firstSowing, estimatedDeliveryDate: $estimatedDeliveryDate, saleOrderId: $saleOrderId) {
      success
    }
  }
`;
</script>

<style scoped></style>

<!--
mutation {
  createSale(
    customerId: 3,
    deliveryDate: "2020-01-31",
    saleProductsAttributes: [
      {price: 100, quantity: 10, itemId: 14, storehouseId: 3}
    ],
    paymentsAttributes: [
      {value: 1000, numberOfInstallments: 1, initialDate:"2020-01-31", bankAccountId: 1, paymentMethodId: 16}
    ]
  ){
    cashFlow {
      id
    }
    errors
  }
}
 -->
